module.exports = __webpack_public_path__ + "img/setting-outline.7e107a0.svg";